module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-8.f1a0fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-8.jpg
// module id = fK7i
// module chunks = 1